import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { NgSelectModule } from '@ng-select/ng-select';
import { UsuariosAdminComponent } from './usuarios-admin/usuarios-admin.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { UsuarioAdminRoutingModule } from './usuarios-admin-routing.module';
import { EditUsuarioAdminComponent } from './edit-usuario-admin/edit-usuario-admin.component';
import { ListUsuariosAdminComponent } from './components/list-usuarios-admin/list-usuarios-admin.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    SharedModule,
    UsuarioAdminRoutingModule,
    MatIconModule
  ],
  declarations: [
    UsuariosAdminComponent,
    EditUsuarioAdminComponent,
    ListUsuariosAdminComponent
  ]
})
export class UsuariosAdminModule {}
